/**
 * Publishes the height of whatever sits above the header as --dom-bar-height.
 *
 * The menu drawer is fixed to the top of the viewport at a lower z-index than
 * the announcement bar, so the bar paints over the drawer's top strip and
 * swallows whatever is up there - the close button. This measures the strip so
 * the drawer's contents can start below it.
 *
 * Measures the header's own offset rather than looking for a particular bar.
 * The first version matched Attrac's .aph_bar_bar, which broke the moment that
 * app was swapped for Shopify's built-in announcement bar: different markup,
 * different classes, same job. Whatever renders the strip, the distance from
 * the top of the page to the top of the header is the space it occupies.
 *
 * Everything degrades to 0px, which is exactly the layout that existed before
 * this file, so a failure here is invisible rather than broken.
 */
(() => {
  const root = document.body;

  const publish = () => {
    const header = document.querySelector('#header-component');
    if (!header) return;

    // Only trustworthy at the top of the page. Once scrolled, a sticky header
    // has moved and its offset says nothing about the bar above it.
    if (window.scrollY > 2) return;

    const top = Math.max(0, Math.round(header.getBoundingClientRect().top));
    root.style.setProperty('--dom-bar-height', `${top}px`);
  };

  publish();

  // Re-measure on the things that change the strip's height: a rotation or a
  // font swap rewrapping its copy, the app injecting it late, or a visitor
  // dismissing it.
  addEventListener('load', publish);
  addEventListener('resize', publish);

  if ('ResizeObserver' in window) {
    const group = document.querySelector('#header-group');
    if (group) new ResizeObserver(publish).observe(group);
  }

  new MutationObserver(publish).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Stop watching once things have settled. The observer above runs on every
  // DOM change on the page, and the bar is not going to appear for the first
  // time ten seconds in.
  setTimeout(publish, 10000);
})();
